import { useTypedTranslation } from 'app/modules/shared/hooks/use-translation'
import { AuthContext } from 'app/modules/user'
import { ScanProfile, ScanProfileOptions } from 'app/modules/user/features/profile/types'
import { useContext, useMemo } from 'react'
import { getAdvancedOptionsFields } from '../components/file-upload-modal/helpers'
import { TFunction } from 'i18next'
import { applicationConfiguration } from 'app/modules/shared'

export function useScanProfiles() {
  const { _t } = useTypedTranslation()
  const { user } = useContext(AuthContext)
  const config = useContext(applicationConfiguration)
  const profiles = user?.scanProfiles ?? []

  const profilesData = useMemo(() => {
    let fields = getAdvancedOptionsFields(_t as TFunction)
    let defaultProfile: string | undefined
    const scanProfiles: ScanProfile[] = []
    const customDefaults = {} as ScanProfileOptions

    // Get default scan profile ID, all scan profiles and filter out unavailable fields
    profiles.forEach((item) => {
      if (!defaultProfile && item.is_default) {
        defaultProfile = item.id
      }
      if (item.name === config.availableOptionsScanProfile) {
        fields = fields.filter((field) => item.options[field.name])
      } else {
        scanProfiles.push(item)
      }
    })

    // Fallback in case no default profile is set
    if (!defaultProfile) {
      defaultProfile = profiles.find((profile) => profile.name === config.initialScanProfile)?.id
    }

    // From available fields, compute default values for custom scan profile and disable file download when needed
    fields.forEach((item, index) => {
      customDefaults[item.name] = true
      if (!config.automaticReportFilesDownload && item.name === 'files_download') {
        fields[index].note = _t('files-download-warning')
        fields[index].disabled = true
      }
    })

    return { defaultProfile, scanProfiles, customDefaults, fields }
  }, [profiles])

  return profilesData
}
